import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'pairingTokens',
  modelName: 'pairing_tokens',
  crud: true,
  endpoint: '/v2/pairing_tokens'
});
